export enum PaymentStatus {
  IN_PROGRESS = "IN_PROGRESS",
  LATE = "LATE",
  FINISHED = "FINISHED",
  DEFAULT = "DEFAULT",
}
